export default __webpack_public_path__ + "static/media/23.f5d62133.png";